// extracted by mini-css-extract-plugin
var _1 = "gU1Tf";
var _2 = "SFQkX";
export { _1 as "appModule", _2 as "fullBleed" }
